import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import _ from "lodash";
import {fetchCategoriesRootMedia} from "../../../../../creators/categories.rootChildrens";
import {updateMediaCategories} from "../../../../../creators/media";
import {PageLoader} from "../../../../components/Loader";
import Icon from "../../../../components/Icon";
import "./Categories.scss";
import {Button} from "../../../../components/Button";


class Categories extends React.Component {
    static defaultProps = {
        stateTagsProtagonist: []
    };

    constructor(props) {
        super(props);
        this.state = {
            categoryActive : {},
            categories : Array.isArray(this.props.categoriesMedia) ? this.props.categoriesMedia.map(cat => cat._id) : [],
            categoriesTmp : []
        };
        this.handleCategories = this.handleCategories.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.props.fetchCategoriesRootMedia();
    }

    handleCategories(id, parentId){
        let categories = this.state.categoriesTmp;
        let isPresent = categories.includes(id.toString());

        let getParent = _.find(this.props.categories, { '_id': parentId._id });


        if(!getParent.isMultipleSelection){
            let idsChildrens = getParent.childrens.map(item => item._id.toString());
            categories = categories.filter(item => !idsChildrens.includes(item.toString()));
            isPresent = false;
        }
        if(isPresent){
            categories = categories.filter(item => item.toString() !== id.toString());
        }
        else if(!isPresent){
            categories.push(id.toString());
        }

        this.setState({categoriesTmp : categories});
        /*if(typeof this.props.updateCategories === "function"){
            this.props.updateCategories(categories);
        }*/

    }

    handleSubmit(){
        let categories = this.state.categoriesTmp;
        this.setState({categories, categoriesTmp : [], categoryActive : {}});
        this.props.updateMediaCategories(this.props.mediaId, {categoriesIds : categories});
    }


    render() {
        return (
            <div id={"media-categories"}>
                {!this.props.categoriesInitialized ? (
                    <PageLoader/>
                ) : (
                    <div className={"media-categories-list"}>
                        {!this.state.categoryActive._id && this.props.categories.map(category =>{
                            let isLockedParent = category.childrens.filter(item => this.props.categoriesHistory[item._id.toString()] && this.props.categoriesHistory[item._id.toString()].isLocked  && this.props.categoriesHistory[item._id.toString()].isValided && !category.isMultipleSelection).length ? true : false;
                            let count = category.childrens.filter(subCat=> this.state.categories.includes(subCat._id.toString())).length;
                            return (
                                <div
                                    key={category._id}
                                    className={"media-categories-list-category"}
                                    onClick={() => this.setState({categoryActive : {...category, isLockedParent}, categoriesTmp : [...this.state.categories]})}
                                >
                                    {count > 0 ? <span className={`media-categories-list-category-badge`}>{!category.isMultipleSelection ? <Icon type={"check"} /> : count }</span> : null}
                                    <Icon type={category.slug} />
                                    {category.title}
                                </div>
                            )
                        })}
                        {this.state.categoryActive._id ? (
                            <div className={"media-categories-list-category-active"}>
                                <div className={"media-categories-list-category-title"}><Icon type={this.state.categoryActive.slug} /> {this.state.categoryActive.title}</div>
                                {this.state.categoryActive.isLockedParent ? (
                                    <div className="media-categories-list-category-info">
                                        Cette information a été choisie par un modérateur de Voissa. Vous ne pouvez pas la modifier.
                                    </div>)
                                : null}
                                <div className={"media-categories-list-category-childs"}>
                                    {this.state.categoryActive.childrens.map(subCat => {
                                        let historyTag = this.props.categoriesHistory[subCat._id.toString()];
                                        return (
                                            <Button
                                                key={subCat._id}
                                                size={"small"}
                                                btnStyle={"grey"}
                                                className={`
                                                    ${this.state.categoriesTmp.includes(subCat._id.toString()) ? "category-valided" : ""}
                                                    ${historyTag && historyTag.isLocked && !this.state.categoryActive.isLockedParent ? "category-locked" : ""}
                                                    ${this.state.categoryActive.isLockedParent ? "category-parent-locked" : ""}
                                                    ${historyTag && historyTag.isValided ? "category-valided" : ""}
                                                    ${historyTag && !historyTag.isValided && historyTag.isLocked ? "category-invalided" : ""}
                                                `}
                                                onClick={() => this.state.categoryActive.isLockedParent || (historyTag && !historyTag.isValided && historyTag.isLocked) ? null : this.handleCategories(subCat._id,subCat.parentId)}
                                                content={subCat.title}/>
                                        )
                                    })}
                                </div>
                                <div className={"media-categories-list-category-footer"}>
                                    <Button
                                        size={"small"}
                                        btnStyle={"grey"}
                                        className={"btn-cancel"}
                                        onClick={() => this.setState({categoryActive : {}, categoriesTmp : []})}
                                        content={"Annuler"}
                                    />
                                    {!this.state.categoryActive.isLockedParent ? <Button
                                        btnStyle={"primary-reverse"}
                                        size={"small"}
                                        className={"ml-8"}
                                        onClick={() => this.handleSubmit()}
                                        content={"Valider"}
                                    /> : null}
                                </div>
                            </div>
                        ) : null}
                    </div>
                )}
                {!this.state.categoryActive._id ? (
                    <div className={"media-categories-list-category-footer footer-desktop"}>
                        <Button
                            size={"small"}
                            btnStyle={"grey"}
                            className={"btn-cancel"}
                            onClick={() => this.props.handleClose()}
                            content={"Fermer"}
                        />
                    </div>
                ) : null}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        categories: state.categoriesRoot.data,
        categoriesLoading: state.categoriesRoot.loading,
        categoriesInitialized: state.categoriesRoot.initialized,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchCategoriesRootMedia,
    updateMediaCategories
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Categories);
